import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { Whatshot } from '@mui/icons-material';

const HypeRating = ({ content, movie, dominantColor = '#6366f1' }) => {
  const data = content || movie;
  const hypeRating = data?.hypeRating || 0;
  const totalInteractions = data?.totalInteractions || 0;
  
  const getHypeLevel = (rating) => {
    if (rating >= 8) return { label: 'Viral', color: '#ff4444' };
    if (rating >= 6) return { label: 'Hot', color: '#ff8800' };
    if (rating >= 4) return { label: 'Trending', color: '#ffaa00' };
    if (rating >= 2) return { label: 'Rising', color: '#44aa44' };
    return { label: 'New', color: '#888888' };
  };

  const hypeLevel = getHypeLevel(hypeRating);

  return (
    <Box sx={{ 
      p: 2,
      background: `linear-gradient(45deg, ${dominantColor}20, ${dominantColor}10)`,
      borderRadius: 2,
      border: `1px solid ${dominantColor}30`
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <Whatshot sx={{ color: hypeLevel.color, fontSize: 24 }} />
        <Typography variant="h6" sx={{ color: hypeLevel.color, fontWeight: 'bold' }}>
          HypeRating
        </Typography>
        <Typography variant="h4" sx={{ color: hypeLevel.color, fontWeight: 'bold' }}>
          {hypeRating.toFixed(1)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          /10
        </Typography>
      </Box>
      
      <LinearProgress 
        variant="determinate" 
        value={(hypeRating / 10) * 100}
        sx={{ 
          height: 8, 
          borderRadius: 4,
          backgroundColor: `${hypeLevel.color}20`,
          '& .MuiLinearProgress-bar': {
            backgroundColor: hypeLevel.color
          }
        }}
      />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Typography variant="caption" sx={{ color: hypeLevel.color, fontWeight: 'bold' }}>
          {hypeLevel.label}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {totalInteractions} interactions
        </Typography>
      </Box>
    </Box>
  );
};

export default HypeRating;